<div  class=" mainLoginContainer container-fluid">
  <div class="mainLoginContainer1 row main-content bg-success text-center">
    <div class="col-md-4 text-center company__info">
      <!-- <span class="company__logo"><h2><span class="fa fa-android"></span></h2></span> -->
      <img src="../../assets/img/frankylogo.svg" class="frankylogo">
    </div>
    <div class="col-md-8 col-xs-12 col-sm-12 login_form ">
      <div class="loginContainer container-fluid">
        <div class="row">
          <h2 style="color:black;">Login</h2>
        </div>
        <div class="row">
          <form control="" class="form-group">
             <div class="row">
              <input [(ngModel)]="newCustomer.EmailId" type="text" name="emailId" id="emailId" class="form__input" placeholder="Email Id" (ngModelChange)="syncNames()">
            </div>
            <!-- <div class="row">
              <input [(ngModel)]="newCustomer.Contact" type="text" name="contact" id="contact" class="form__input" placeholder="Mobile no">
            </div> -->
            <div class="row">
              <input [(ngModel)]="newCustomer.CustomerName" type="text" name="customerName" id="customerName" class="form__input" placeholder="Name" (ngModelChange)="syncCustomerName()">
            </div>
           
           
            <div >
              <input type="submit" value="Get OTP" class="Submitbtn" (click)="GetOtp()">
            </div>
          </form>
        </div>
        <div class="row">
          <p>Don't have an account? <a (click)="registerButton();" style="cursor: pointer;color: cadetblue;">Register Here</a></p>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- OTP Modal -->
<div class="modal-backdrop" *ngIf="isOtpModalVisible">
  <div class="otp-modal">
    <h3>Enter OTP</h3>
    <input [(ngModel)]="enteredOtp" maxlength="6" placeholder="Enter OTP" />
    
    <div class="modal-buttons">
      <!-- <button (click)="submitOtp()">Submit</button> -->
        <button (click)="loginAuthFn()">Submit</button>
      <button (click)="closeOtpModal()">Cancel</button>
    </div>
  </div>
</div>




